<template>
    <div id="sidenav-collapse-main" class="collapse navbar-collapse w-auto h-auto">
        <ul class="navbar-nav">
            <li class="nav-item">
                <sidenav-collapse nav-text="Cerrar sesión" :expand="false" :to="{ name: 'Logout' }">
                    <template  #icon>
                        <icon name="logout"/>
                    </template>
                </sidenav-collapse>
            </li>
        </ul>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import SidenavCollapse from '../Sidenav/SidenavCollapse.vue';

export default {
    name: "LogOut",
    components: {
        SidenavCollapse,
        Icon
    }
};
</script>